import sileo from 'sileo';

const Department = new sileo.Model('bposeats', 'company-departments');
const WorkforceDepartment = new sileo.Model('hqzen', 'workforce-departments');
const DepartmentTeam = new sileo.Model('bposeats', 'company-department-in-team');
const SingleDepartment = new sileo.Model('hqzen', 'departments');
const ListDepartment = new sileo.Model('hqzen', 'list-departments');
const HqzenDepartment = new sileo.Model('hqzen', 'departments');
const HqzenTeams = new sileo.Model('hqzen', 'teams');
const DepartmentExitInterviews = new sileo.Model('hqzen', 'department-exit-interviews');


const actions = {
    fetchDepartmentExitInterviews(context, filters) {
        return DepartmentExitInterviews.objects.filter(filters);
    },

    fetchCompanyDepartments(context, filters) {
        return Department.objects.filter(filters);
    },

    fetchWorkforceDepartments(context, filters) {
        return WorkforceDepartment.objects.filter(filters);
    },

    getCompanyDepartmentDetails(context, pk) {
        return DepartmentTeam.objects.get(pk);
    },

    fetchHqzenDepartments(context, filters) {
        return ListDepartment.objects.filter(filters);
    },

    fetchSingleDepartment(context, departmentId) {
        return SingleDepartment.objects.get(departmentId);
    },

    createDepartment(context, data) {
        const form = new FormData();
        form.append('workforce', data.workforce);
        form.append('name', data.name);
        form.append('employments', data.employments);
        form.append('managers', data.managers);

        return HqzenDepartment.objects.create(form);
    },

    updateDepartment(context, data) {
        const { pk, payload } = data;
        const form = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
            form.append(key, value);
        });

        return HqzenDepartment.objects.update({ pk: pk }, form);
    },

    deleteDepartment(context, pk) {
        return HqzenDepartment.objects.delete({ pk });
    },

    createTeam(context, data) {
        const form = new FormData();
        form.append('department', data.department);
        form.append('name', data.name);
        form.append('employments', data.employments);
        form.append('supervisors', data.supervisors);

        return HqzenTeams.objects.create(form);
    },

    updateTeam(context, data) {
        const { pk, payload } = data;
        const form = new FormData();
        Object.entries(payload).forEach(([key, value]) => {
            form.append(key, value);
        });

        return HqzenTeams.objects.update({ pk: pk }, form);
    },

    deleteTeam(context, pk) {
        return HqzenTeams.objects.delete({ pk });
    }
};

export default {
    namespaced: true,
    actions
};
